import { Platform, StyleSheet } from 'react-native';
import type { Theme } from '../../../../src/theme/getTheme';

export const getJoinCodeEntryStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      paddingHorizontal: 20,
      paddingTop: 8,
      backgroundColor: theme.background.primary,
      ...(Platform.OS === 'web' && {
        maxWidth: 440,
        width: '100%',
        alignSelf: 'center' as const,
      }),
    },
    backButton: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
      paddingVertical: 6,
      paddingHorizontal: 4,
      alignSelf: 'flex-start',
      marginBottom: 20,
    },
    backButtonPressed: { opacity: 0.7 },
    backButtonHover: { opacity: 0.85 },
    backButtonText: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.primary,
    },
    badgeChip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      paddingVertical: 4,
      paddingHorizontal: 10,
      borderRadius: 99,
      backgroundColor: theme.primary + '1a',
      borderWidth: 1,
      borderColor: theme.primary + '55',
      alignSelf: 'flex-start',
      marginBottom: 12,
    },
    badgeChipDot: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: theme.primary,
    },
    badgeChipText: {
      fontSize: 10,
      fontWeight: '800',
      color: theme.primary,
      letterSpacing: 1.4,
      textTransform: 'uppercase',
    },
    title: {
      fontSize: 26,
      fontWeight: '900',
      color: theme.gray[900],
      letterSpacing: -0.8,
      lineHeight: 32,
      marginBottom: 8,
    },
    subtitle: {
      fontSize: 13,
      fontWeight: '500',
      color: theme.gray[500],
      lineHeight: 20,
      marginBottom: 28,
    },
    otpWrapper: {
      position: 'relative',
      height: 70,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 14,
    },
    otpBoxRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    // Transparent overlay that receives all taps in the OTP area. Always
    // editable so the keyboard stays up through loading states.
    otpTextInput: {
      ...StyleSheet.absoluteFillObject,
      opacity: 0,
      color: 'transparent',
    },
    // Spinner centered over the OTP row while preview fetch is in-flight
    otpLoadingOverlay: {
      position: 'absolute',
      right: -28,
    },
    otpDash: {
      width: 12,
      height: 3,
      borderRadius: 2,
      backgroundColor: theme.gray[200],
      marginHorizontal: 2,
    },
    otpDashFilled: {
      backgroundColor: theme.primary,
    },
    otpBox: {
      width: 44,
      height: 56,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: theme.gray[200],
      backgroundColor: theme.background.card,
      alignItems: 'center',
      justifyContent: 'center',
    },
    otpBoxFilled: {
      backgroundColor: theme.primary + '1a',
      borderColor: theme.primary + '55',
    },
    otpBoxActive: {
      borderWidth: 2,
      borderColor: theme.primary,
      ...(Platform.OS === 'web' && {
        boxShadow: `0 0 0 4px ${theme.primary}22, 0 0 18px ${theme.primary}44` as never,
      }),
    },
    otpBoxValidating: {
      backgroundColor: theme.success + '22',
      borderColor: theme.success,
      borderWidth: 2,
    },
    otpChar: {
      fontSize: 22,
      fontWeight: '800',
      color: theme.gray[900],
    },
    otpCharValidating: {
      color: theme.success,
    },
    caret: {
      width: 2,
      height: 22,
      borderRadius: 1,
      backgroundColor: theme.primary,
    },
    statusText: {
      textAlign: 'center',
      fontSize: 11,
      color: theme.gray[400],
      marginBottom: 24,
      lineHeight: 16,
    },
    statusTextError: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.error,
    },
    statusTextValidating: {
      fontSize: 12,
      fontWeight: '800',
      color: theme.success,
      letterSpacing: 0.4,
    },
    helperCode: {
      color: theme.gray[500],
      fontWeight: '700',
    },
  });
